var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.attributes),function(attribute,index){return (_vm.limit===0 || (_vm.limit!==0 && index<_vm.limit))?_c('label-value-item',{key:attribute.code,attrs:{"label-value":_vm.constructLabelValueItem(attribute),"with-drawing-code":_vm.withDrawingCode}}):_vm._e()}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }